"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[78979],{

/***/ 78979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41749);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31520);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58365);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86700);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);









var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        root: {
            margin: theme.spacing(4, 0)
        },
        containerFull: {
            padding: 0,
            overflow: 'hidden'
        },
        container: {},
        textInfo: {
            background: theme.palette.primaryTransparent.light,
            height: '400px',
            display: 'flex'
        },
        image: {
            display: 'block',
            width: '100%',
            objectFit: 'cover',
            height: 'auto'
        },
        textDiv: {
            padding: theme.spacing(0, 4),
            margin: 'auto'
        },
        content: {
            '& a': {
                display: 'inline-block'
            },
            '& h2': {
                fontSize: theme.typography.pxToRem(24),
                lineHeight: 1.15
            },
            '& h3': {
                fontSize: theme.typography.pxToRem(15),
                fontWeight: 400,
                '& strong': {
                    fontWeight: 700
                }
            },
            '&>*': {
                marginTop: 0,
                marginBottom: theme.spacing(2)
            },
            '&.left': {
                textAlign: 'left'
            },
            '&.center': {
                textAlign: 'center',
                '& ol, & ul': {
                    textAlign: 'left'
                }
            },
            '&.right': {
                textAlign: 'right',
                '& ol, & ul': {
                    direction: 'rtl'
                }
            }
        },
        contentFull: {
            maxWidth: '65%',
            margin: 'auto'
        },
        skeletonCta: {
            borderRadius: theme.spacing(3),
            height: 45,
            display: 'inline-block'
        }
    });
});
var InformationsSection = function(param) {
    var homePage = param.homePage, t = param.t, _isMoreInfo = param.isMoreInfo, isMoreInfo = _isMoreInfo === void 0 ? false : _isMoreInfo;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().trackEvent;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var isMobile = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(theme.breakpoints.down('sm'));
    var isInfoSection = isMoreInfo ? homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : ref.more_information_section : homePage === null || homePage === void 0 ? void 0 : (ref1 = homePage.data) === null || ref1 === void 0 ? void 0 : ref1.information_section;
    var isFullScreen = isMoreInfo ? homePage === null || homePage === void 0 ? void 0 : (ref2 = homePage.data) === null || ref2 === void 0 ? void 0 : ref2.more_information_fullscreen : homePage === null || homePage === void 0 ? void 0 : (ref3 = homePage.data) === null || ref3 === void 0 ? void 0 : ref3.information_fullscreen;
    var background = isMoreInfo ? (homePage === null || homePage === void 0 ? void 0 : (ref4 = homePage.data) === null || ref4 === void 0 ? void 0 : ref4.more_information_bg) !== null ? homePage.data.more_information_bg : 'none' : (homePage === null || homePage === void 0 ? void 0 : (ref5 = homePage.data) === null || ref5 === void 0 ? void 0 : ref5.information_bg) !== null ? homePage.data.information_bg : 'none';
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('section-infos', 'section__spacer', classes.root, !isMoreInfo ? 'section-infos--1' : 'section-infos--2'),
        style: {
            background: background
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            className: isFullScreen ? classes.containerFull : classes.container,
            maxWidth: isFullScreen ? 'xl' : 'lg',
            children: isInfoSection && isInfoSection.length > 0 && isInfoSection[0].info_text.length > 0 ? isInfoSection.map(function(el, index) {
                var alignContent;
                switch(el.align_content){
                    case 'left':
                        alignContent = 'left';
                        break;
                    case 'center':
                        alignContent = 'center';
                        break;
                    case 'right':
                        alignContent = 'right';
                        break;
                    default:
                        alignContent = 'right';
                }
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    container: true,
                    justify: 'center',
                    alignItems: 'center',
                    spacing: isFullScreen ? isMobile ? 2 : 0 : 3,
                    direction: el.image_align ? 'row-reverse' : 'row',
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            item: true,
                            md: 6,
                            xs: 12,
                            children: el.info_image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "section-infos__image ".concat(classes.image),
                                src: el.info_image.url,
                                width: el.info_image.width,
                                height: el.info_image.height,
                                alt: ""
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                width: '100%',
                                height: 400,
                                animation: false,
                                className: "section-infos__image ".concat(classes.image)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            item: true,
                            md: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: isFullScreen ? "section-infos__content ".concat(classes.contentFull, " ").concat(classes.content, " ").concat(alignContent) : "section-infos__content ".concat(classes.content, " ").concat(alignContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                        data: el === null || el === void 0 ? void 0 : el.info_text,
                                        defaultText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            variant: "text"
                                        })
                                    }),
                                    (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .isPrismicText */ .LT)(el === null || el === void 0 ? void 0 : el.button_text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        href: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.link_button),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                variant: 'contained',
                                                color: 'primary',
                                                className: 'section-infos__cta',
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'HomePage',
                                                        href: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.link_button),
                                                        action: "CTA click ".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.button_text)),
                                                        name: "from Information section to ".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.link_button))
                                                    });
                                                },
                                                children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(el === null || el === void 0 ? void 0 : el.button_text)
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, index));
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                container: true,
                justify: 'center',
                alignItems: 'center',
                spacing: 3,
                direction: 'row-reverse',
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "section-infos__image ".concat(classes.image),
                            src: '/images/placeholder.jpg',
                            width: '500px',
                            height: '500px',
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(classes.content, " ", 'left'),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: t('texts:general:add_a_text')
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    href: '/shop',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            variant: 'contained',
                                            color: 'primary',
                                            children: t('texts:general:add_a_text')
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (InformationsSection);


/***/ })

}]);